import { PcbNodeTypes } from "@buildwithflux/models";
import { getNodesOfType } from "../../../../nodes";
export const mapNet = (net, 
// TODO: Remove unused params
context, postprocess, pcbLayoutNodes) => {
    if (!pcbLayoutNodes)
        return null;
    const index = getNodesOfType(pcbLayoutNodes, PcbNodeTypes.net).indexOf(net);
    const netNumber = index + 1;
    return {
        name: net.name,
        net_number: netNumber,
    };
};
//# sourceMappingURL=mapNet.js.map